/* jshint esversion: 6 */
/* jshint ignore:start */
import { createContext, useState } from 'react';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const BaseUrl = "https://magicmate.cscodetech.cloud/";

    // OneSignal Customer AppId 
    const OneSingalAppidCO = "c6210845-fb22-498c-a091-a82c5e916f89";

    // OneSignal Organizer AppId & Key
    const OneSingalAppidOR = "6420ad00-cb63-43ab-9a45-0ca51ad272d1";
    const OneSingalKeyOR = "os_v2_app_mqqk2aglmnb2xgsfbssrvuts2eoilvsmfrxuyzngji7dgx4ou6ucczksccqkzssri5433wjnopbtog7kaz5wz7tn5kj4urjktiqw3wy";

    // Map Key
    const MapKey = "AIzaSyDZQPb2cuTOdunZdBXOVw9Rt8JhRPZydhg";


    const [isLoginShow, setIsLoginShow] = useState(false);
    const [isSignUpShow, setIsSignUpShow] = useState(false);
    const [isLogin, setIsLogin] = useState("");
    const [paymentRes, setPaymentRes] = useState();
    const [transactionId, setTransactionId] = useState();
    const [paymentLoad, setPaymentLod] = useState(false);
    const [isValidate, setIsValidate] = useState(false);

    const Value = {
        isLoginShow, setIsLoginShow,
        isSignUpShow, setIsSignUpShow,
        isLogin, setIsLogin,
        paymentRes, setPaymentRes,
        transactionId, setTransactionId,
        paymentLoad, setPaymentLod,
        isValidate, setIsValidate,
        OneSingalAppidCO,
        OneSingalAppidOR, OneSingalKeyOR,
        BaseUrl, MapKey
    };

    return (
        <MyContext.Provider value={Value}>
            {children}
        </MyContext.Provider>
    );
};

export { MyContext, MyProvider };
/* jshint ignore:end */
